function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 5217"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 153538",
    style: {
      fill: "#fff"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.115-851.806-2.63-2.63.89-.89 1.739 1.739 3.463-3.463.89.89zm-4.631 2.886a1.432 1.432 0 0 1-1.053-.431A1.432 1.432 0 0 1 140-850.4v-10.99a1.432 1.432 0 0 1 .431-1.053 1.432 1.432 0 0 1 1.053-.431h1.136v-1.736h1.263v1.736h6.217v-1.736h1.231v1.736h1.136a1.432 1.432 0 0 1 1.053.431 1.432 1.432 0 0 1 .431 1.053v10.99a1.432 1.432 0 0 1-.431 1.053 1.432 1.432 0 0 1-1.053.431zm0-1.231h10.986a.241.241 0 0 0 .174-.079.241.241 0 0 0 .079-.174v-7.7h-11.492v7.7a.241.241 0 0 0 .079.174.241.241 0 0 0 .174.078zm-.253-9.186h11.491v-2.052a.241.241 0 0 0-.079-.174.241.241 0 0 0-.174-.079h-10.985a.241.241 0 0 0-.174.079.241.241 0 0 0-.079.174zm0 0z",
    transform: "translate(-136.942 866.8)",
    style: {
      fill: "#909090"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e52d8ea5f1a3bf8b90780b0904a3effe.svg";
export { ForwardRef as ReactComponent };